<template>
  <v-btn
    v-if="false"
    block
    width="auto" height="auto" 
    text
    tile
    class="pa-0"
    href="https://www.directv.com/business"
    target="_blank"
  >
    <v-img
      aspect-ratio="8.088888888888889"
      max-width="728"
      contain
      src="/images/ads/callnow/call-now-728x90.jpg"
    />
  </v-btn>
</template>

<script>
export default {
  name: "Ad",
  computed: {
    isCommercial() {
      return this.$store.getters.getIsCommercial;
    },
  },
};
</script>

<style scoped>
.v-btn:before {
  display: none;
}
</style>